import React, { Fragment, useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { connectDriver, editDriverProfile, getAllDrivers, reVerifyDriver, verifyDriver } from "../../Services/DriverService";
import Swal from "sweetalert2";
import { CardBody, Col, Input, Label, Media } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import { Modal, Button, ListGroup } from "react-bootstrap";
import { FaPlus } from "react-icons/fa"; 
import { IoChatboxEllipsesOutline } from "react-icons/io5";
import { useNavigate } from "react-router";
import { BiSolidUserDetail } from "react-icons/bi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Link } from "react-router-dom";

const DriverTable = () => {
  // State for driver data and loading spinner
  const [driverList, setDriverList] = useState([]);
  const [pending, setPending] = useState(true);
  const [openUserDetailModal, setOpenUserDetailModal] = useState(false);

  // State for Connect modal, selected row, and text input value
  const [showConnectModal, setShowConnectModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [driverConnectId, setDriverConnectId] = useState("");
  const [showEditModal, setShowEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [drivingLicence, setDrivingLicence] = useState(null);
  const [carDocument, setCarDocument] = useState(null);
  const [carInsurance, setCarInsurance] = useState(null);
  const [filteredUserList, setFilteredUserList] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);

  const navigate = useNavigate();

  // Columns definition for the DataTable
  const Columns = [
    {
      name: "Driver Name",
      selector: (row) => row["full_name"],
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Joined On",
      selector: (row) => row["createdAt"],
      sortable: true,
      center: false,
      minWidth: "100px",
      maxWidth: "180px",
      cell: (row) => (
          <>
              <div>{formattedDate(row?.createdAt)}</div>
          </>
      )
    },
    {
      name: "Details",
      center: true,
      minWidth: "60px",
      maxWidth: "120px",
      cell: (row) => (
        <>
          <div
            onClick={
              () => {
                setOpenUserDetailModal(true);
                setSelectedRow(row);
              }
            }
            style={{
              cursor: "pointer"
            }}
          >
            <BiSolidUserDetail size={24} />
          </div>
        </>
      ),
    },
    {
      name: "Driving licence",
      sortable: true,
      center: true,
      minWidth: "50px",
      maxWidth: "146px",
      selector: (row) => (
        <a
          href={row["driving_licence"]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <i className="fa fa-external-link" aria-hidden="true"></i>
        </a>
      ),
    },
    {
      name: "Car document",
      sortable: true,
      center: true,
      minWidth: "50px",
      maxWidth: "120px",
      selector: (row) => (
        <a
          href={row["car_document"]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <i className="fa fa-external-link" aria-hidden="true"></i>
        </a>
      ),
    },
    {
      name: "Insurance",
      sortable: true,
      center: true,
      minWidth: "50px",
      maxWidth: "120px",
      selector: (row) => (
        <a
          href={row["car_insurance"]}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <i className="fa fa-external-link" aria-hidden="true"></i>
        </a>
      ),
    },
    {
      name: "Verify",
      sortable: true,
      center: true,
      minWidth: "50px",
      maxWidth: "120px",
      selector: (row) => (
        <Media body className="text-end icon-state switch-outline">
          <Label className="switch">
            <Input
              type="checkbox"
              checked={row["is_driver_profile_approved"]}
              onChange={() => handleToggle(row)}
            />
            <span className="switch-state bg-success"></span>
          </Label>
        </Media>
      ),
    },
    {
      name: "Re-Verify",
      sortable: true,
      center: true,
      minWidth: "100px",
      maxWidth: "180px",
      selector: (row) => (
        row?.reverify_status !== "" ? (
          <Media body className="text-end icon-state switch-outline">
            {row?.reverify_status === "Pending" ? (
              <Button variant="warning" size="sm" style={{ cursor: "pointer", color: "black", fontFamily: "Rubik, sans-serif" }} onClick={(e) => handleReverify(e, row)} >
                Pending
              </Button>
            ) : row?.reverify_status === "Approved" ? (
              <Button variant="dark" size="sm" style={{ cursor: "not-allowed" }} disabled>
                Verified
              </Button>
            ) : "-"}
          </Media>
        ) : (
          "-"
        )
      ),
    },
    {
      name: "Connect",
      minWidth: "200px",
      maxWidth: "210px",
      cell: (row) => (
        <>
            {
                row?.stripe_connect_id ? (
                    row["stripe_connect_id"]
                ) : (
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={() => openConnectModal(row)}
                        style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "0",
                        }}
                        >
                        <FaPlus />
                    </Button>
                )
            }
        </>
      ),
    },
    {
      name: "Chat",
      minWidth: "50px",
      maxWidth: "120px",
      cell: (row) => (
          <>
              <div
                  onClick={
                      () => navigate(`/user-chat/${row?._id}`, { 
                        replace: true,
                        state: {
                          user_id: row?._id,
                          full_name: row?.full_name,
                          role: row?.role,
                        } 
                      })
                  }
                  style={{
                      cursor: "pointer"
                  }}
              >
                  <IoChatboxEllipsesOutline size={24} />
              </div>
          </>
      ),
    },
    {
      name: "Edit",
      minWidth: "50px",
      maxWidth: "120px",
      center: true,
      cell: (row) => (
        <Button
          variant="info"
          size="sm"
          onClick={() => openEditModal(row)}
          style={{ cursor: "pointer" }}
        >
          Edit
        </Button>
      ),
    },    
  ];

  const openEditModal = (row) => {
    const prepareData = {
      _id: row?._id,
      full_name: row?.full_name,
      email: row?.email,
      phone: row?.phone,
      car_name: row?.car_name,
      driving_licence_number: row?.driving_licence_number,
      stripe_connect_id: row?.stripe_connect_id,
      driving_licence: row?.driving_licence.split("uploads/")[1],
      car_document: row?.car_document.split("uploads/")[1],
      car_insurance: row?.car_insurance.split("uploads/")[1],
    };

    setEditData(prepareData);
    setShowEditModal(true);
  };  

  // Fetch all drivers
  const getAllDriverList = async () => {
    try {
      const res = await getAllDrivers();
      setDriverList(res.data);
      setFilteredUserList(res.data);
    } catch (error) {
      console.log(error);
    } finally {
      setPending(false);
    }
  };

  // Handle toggle of driver verification status
  const handleToggle = async (row) => {
    const currentStatus = row["is_driver_profile_approved"];
    const driver_id = row["_id"];

    Swal.fire({
      title: currentStatus
        ? "Do you want to remove verification?"
        : "Do you want to verify driver profile?",
      showCancelButton: true,
      confirmButtonText: "Save",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await verifyDriver({
            driver_id,
            is_driver_profile_approved: !currentStatus,
          });

          if (res.success) {
            Swal.fire(
              "Saved!",
              "The changes have been saved successfully.",
              "success"
            );
          }
        } catch (error) {
          console.error("Error updating verification status:", error);
          Swal.fire(
            "Error",
            "Failed to save changes. Please try again.",
            "error"
          );
        } finally {
          getAllDriverList();
        }
      }
    });
  };

  // Open the Connect modal for the selected row
  const openConnectModal = (row) => {
    setSelectedRow(row);
    setShowConnectModal(true);
  };

  // Modal submit handler: log the input text along with the selected row data
  const handleConnectModalSubmit = async () => {
    try {
        const passData = {
            _id: selectedRow?._id,
            driver_connect_id: driverConnectId,
        };

        const response = await connectDriver(passData);
        if (response.success) {
            Swal.fire(
                "Connected!",
                "Driver connected with Stripe connect id",
                "success",
            );
        }
    } catch (error) {
        console.log("Error: ", error);
    } finally {
        getAllDriverList();
    }

    setDriverConnectId("");
    setShowConnectModal(false);
  };

  const handleReverify = async (e, row) => {
    e.preventDefault();

    try {
      const passData = {
        _id: row?._id
      };

      const response = await reVerifyDriver(passData);
      if (response.success) {
        Swal.fire(
          "Re-Verified!",
          "Driver profile verified",
          "success",
      );
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      getAllDriverList();
    }
  };

  useEffect(() => {
    getAllDriverList();
  }, []);

  const handleEditSubmit = async () => {
    try {
      const formData = new FormData();

      Object.entries(editData).forEach(([key, value]) => {
        if (
          key !== "driving_licence" &&
          key !== "car_document" &&
          key !== "car_insurance"
        ) {
          formData.append(key, value);
        }
      });

      if (drivingLicence) formData.append("driving_licence", drivingLicence);
      if (carDocument) formData.append("car_document", carDocument);
      if (carInsurance) formData.append("car_insurance", carInsurance);

      const response = await editDriverProfile(formData);

      if (response.success) {
        Swal.fire(
          "Updated!",
          "Driver profile updated successfully",
          "success",
        );

        getAllDriverList();
      }
    } catch (error) {
      console.log("Error: ", error);
    }
    setShowEditModal(false);
  };

  const formattedDate = (createdDate) => {
    const date = new Date(createdDate);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  useEffect(() => {
      if (!selectedDate) {
          setFilteredUserList(driverList);
      } else {
          const filtered = driverList.filter(user => {
              const created = new Date(user.createdAt);
              return created.toDateString() === selectedDate.toDateString();
          });
          setFilteredUserList(filtered);
      }
  }, [selectedDate, driverList]);

  return (
    <Fragment>
      <div className="d-flex justify-content-end align-items-center mb-3">
        <label className="me-2"><strong>Filter by Date:</strong></label>
        <DatePicker
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            placeholderText="Select date"
            className="form-control"
            maxDate={new Date()}
            isClearable
        />
      </div>

      {/* Data Table */}
      <div className="table-responsive support-table">
        {pending ? (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        ) : (
          <DataTable
            columns={Columns}
            data={filteredUserList}
            striped
            center
            pagination
          />
        )}
      </div>

      {/* Modal for User Details */}
      <Modal show={openUserDetailModal} onHide={() => setOpenUserDetailModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Driver Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">
            <ListGroup variant="flush">
              <ListGroup.Item className="mb-2">
                <strong>Name:</strong> {selectedRow?.full_name || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>Email:</strong> {selectedRow?.email || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>Phone:</strong> {selectedRow?.phone || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>Car Name:</strong> {selectedRow?.car_name || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>Driving Licence Number:</strong> {selectedRow?.driving_licence_number || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>Address:</strong> {selectedRow?.address || "N/A"}
              </ListGroup.Item>
              <ListGroup.Item className="mb-2">
                <strong>State ID:</strong>
                <a href={selectedRow?.state_id}
                  target="_blank"
                  rel="noopener noreferrer"> {selectedRow?.state_id.length > 20 ? selectedRow?.state_id.slice(0, 45) + "..." : selectedRow?.state_id || "N/A"}
                </a>
              </ListGroup.Item>
            </ListGroup>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setOpenUserDetailModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal for Connect action */}
      <Modal
        show={showConnectModal}
        onHide={() => setShowConnectModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Connect Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Stripe Connect ID"
            value={driverConnectId}
            onChange={(e) => setDriverConnectId(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConnectModal(false)}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleConnectModalSubmit}
            disabled={driverConnectId.trim().length === 0}
          >
            Submit
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal for Edit action */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit Driver Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label"><strong>Full Name</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Full Name"
              value={editData.full_name || ""}
              onChange={(e) => setEditData({ ...editData, full_name: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Email</strong></label>
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={editData.email || ""}
              onChange={(e) => setEditData({ ...editData, email: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Phone</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Phone"
              value={editData.phone || ""}
              onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
              disabled
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Car Name</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Car Name"
              value={editData.car_name || ""}
              onChange={(e) => setEditData({ ...editData, car_name: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Driving Licence Number</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Driving Licence Number"
              value={editData.driving_licence_number || ""}
              onChange={(e) => setEditData({ ...editData, driving_licence_number: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Stripe Connect ID</strong></label>
            <input
              type="text"
              className="form-control"
              placeholder="Connect ID"
              value={editData.stripe_connect_id || ""}
              onChange={(e) => setEditData({ ...editData, stripe_connect_id: e.target.value })}
            />
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Driving Licence</strong></label>
            <input
              type="file"
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
              onChange={(e) => setDrivingLicence(e.target.files[0])}
            />
            <label className="form-label">{editData?.driving_licence}</label>
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Car Document</strong></label>
            <input
              type="file"
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
              onChange={(e) => setCarDocument(e.target.files[0])}
            />
            <label className="form-label">{editData?.car_document}</label>
          </div>

          <div className="mb-3">
            <label className="form-label"><strong>Car Insurance</strong></label>
            <input
              type="file"
              className="form-control"
              accept=".jpg,.jpeg,.png,.pdf,.doc,.docx"
              onChange={(e) => setCarInsurance(e.target.files[0])}
            />
            <label className="form-label">{editData?.car_insurance}</label>
          </div>
        </Modal.Body>
        
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowEditModal(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleEditSubmit}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

    </Fragment>
  );
};

export default DriverTable;
